export default "__VITE_ASSET__907cf424__"